// Is a given value a DOM element?
export default function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isElement.js
// module id = 1935
// module chunks = 1